import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';

function Works() {
  const [showModal, setShowModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      title: "برنامج تدريبي",
      desc: "تصميم برنامج لبناء القدرات البشرية لموظفي القطاع العام.",
      img: "/1.jpg", // Using the same image as the background for consistency
      fullDetails: "هذا البرنامج يهدف إلى تعزيز مهارات موظفي القطاع العام من خلال تدريبات مكثفة تركز على القيادة، إدارة الوقت، والتواصل الفعال. تم تنفيذه على مدى 6 أشهر مع نتائج ملحوظة في تحسين الأداء."
    },
    {
      title: "حملة إعلامية",
      desc: "إطلاق حملة توعوية وطنية لتعزيز التواصل الاستراتيجي.",
      img: "/2.jpg",
      fullDetails: "حملة إعلامية وطنية استهدفت الجمهور العام لنشر الوعي حول أهمية التواصل الاستراتيجي. شملت إعلانات تلفزيونية ومنشورات على وسائل التواصل الاجتماعي، وحققت تفاعلاً كبيرًا."
    },
    {
      title: "استشارات تنظيمية",
      desc: "تقديم حلول لتحسين هيكلة مؤسسة خاصة.",
      img: "/3.jpg",
      fullDetails: "تم تقديم استشارات لإعادة هيكلة مؤسسة خاصة، مع التركيز على تحسين العمليات الداخلية وزيادة الكفاءة. شملت المشروع تحليلًا شاملاً وتوصيات تم تطبيقها بنجاح."
    },
    {
      title: "ورشة عمل",
      desc: "تنظيم ورشة لتطوير مهارات القيادة للشباب.",
      img: "/4.jpg",
      fullDetails: "ورشة عمل استمرت 3 أيام، ركزت على تطوير مهارات القيادة للشباب من خلال أنشطة تفاعلية وجلسات عملية. شارك فيها أكثر من 50 شابًا وحققت نجاحًا كبيرًا."
    },
  ];

  const handleShowModal = (project) => {
    setSelectedProject(project);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProject(null);
  };

  return (
    <div className="works-page">
      <Container className="py-5 position-relative page-content">
        <h2 className="text-center mb-5 page-title aref-ruqaa">مشاريع</h2>
        <Row>
          {projects.map((project, index) => (
            <Col md={6} lg={3} key={index} className="mb-4">
              <Card className="work-card shadow-lg">
                <Card.Img variant="top" src={project.img} alt={project.title} />
                <Card.Body className="text-bg-blur">
                  <Card.Title>{project.title}</Card.Title>
                  <Card.Text>{project.desc}</Card.Text>
                  <Button
                    variant="outline-light"
                    onClick={() => handleShowModal(project)}
                  >
                    عرض التفاصيل
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Modal for Project Details */}
        {selectedProject && (
          <Modal
            show={showModal}
            onHide={handleCloseModal}
            centered
            dir="rtl"
            className="custom-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>{selectedProject.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{selectedProject.fullDetails}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-light" onClick={handleCloseModal}>
                إغلاق
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Container>
    </div>
  );
}

export default Works;